import styles from "./stepper.module.css";
import { FaCheck } from "react-icons/fa6";

const Stepper = ({ steps, currentStep }) => {
  const progressWidth = ((currentStep - 1) / (steps.length - 1)) * 100;

  return (
    <div className={styles.progressBarContainer}>
      <div className={styles.stepperWrapper}>
        <div className={styles.lineContainer}>
          <div
            className={styles.lineProgress}
            style={{ width: `${progressWidth}%` }}
          />
        </div>

        <div className={styles.stepsContainer}>
          {steps.map((step) => {
            const isCompleted = step.number < currentStep;
            const isActive = step.number === currentStep;

            return (
              <div key={step.number} className={styles.stepWrapper}>
                <div
                  className={`${styles.stepCircle} 
                    ${isActive ? styles.stepCircleActive : ""} 
                    ${isCompleted ? styles.stepCircleComplete : ""}`}
                >
                  {isCompleted ? <FaCheck size={14} /> : step.number}
                </div>

                <div
                  className={`${styles.stepLabel} 
                    ${isActive ? styles.stepLabelActive : ""}`}
                >
                  {step.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Stepper;
